const ShippingAddressSkeleton = () => {
    return (
        <div className="myaccountDiv shipDiv">
            <ul>
                <li>
                    <div className="skeleton" style={{ width: 100, height: 14, marginBottom: 8 }} />
                    <div className="skeleton" style={{ width: "55%", height: 18 }} />
                </li>
                <li>
                    <div className="skeleton" style={{ width: 90, height: 14, marginBottom: 8 }} />
                    <div className="skeleton" style={{ width: "75%", height: 18 }} />
                </li>
                <li>
                    <div className="skeleton" style={{ width: 80, height: 14, marginBottom: 8 }} />
                    <div className="skeleton" style={{ width: 120, height: 18 }} />
                </li>
                <li>
                    <div className="skeleton" style={{ width: 60, height: 14, marginBottom: 8 }} />
                    <div className="skeleton" style={{ width: "35%", height: 18 }} />
                </li>
                <li>
                    <div className="skeleton" style={{ width: 80, height: 14, marginBottom: 8 }} />
                    <div className="skeleton" style={{ width: "30%", height: 18 }} />
                </li>
                <li>
                    <div className="skeleton" style={{ width: 90, height: 34, display: "inline-block", marginRight: 10 }} />
                    <div className="skeleton" style={{ width: 80, height: 34, display: "inline-block" }} />
                </li>
            </ul>

            <h3 className="dflt">
                <div className="skeleton" style={{ width: 190, height: 16 }} />
            </h3>
        </div>
    );
};

export default ShippingAddressSkeleton;
